import React from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiMapPin,FiPhone}=FiIcons;
const areas=['Goulburn, NSW','Rockdale, NSW'];

function ServiceAreas() {
  return (
    <section className="areas-section section-pad" id="areas">
      <div className="page-width">
        <div className="section-heading centered">
          <span className="eyebrow">Where we teach</span>
          <h2>Lessons available in <span>NSW.</span></h2>
          <p>Automatic driving lessons are based in these areas.</p>
        </div>
        <div className="areas-grid">
          {areas.map((area,i)=> (
            <motion.div className="area-card" key={area} initial={{opacity: 0,y: 18}} whileInView={{opacity: 1,y: 0}} viewport={{once: true}} transition={{duration: 0.4,delay: i * 0.1}}>
              <span className="area-icon"><SafeIcon icon={FiMapPin} /></span>
              <h3>{area}</h3>
            </motion.div>
          ))}
        </div>
        <div className="areas-note">
          <p>Near the Greater Sydney area and want to book? Call Milan to check availability.</p>
          <a className="button button-primary" href="tel:0433037815"><SafeIcon icon={FiPhone} /> Call 0433 037 815</a>
        </div>
      </div>
    </section>
  );
}

export default ServiceAreas;